import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "../components/common/Button";
import history from "../utils/history";
import { selectHasCompletedTourGuide } from "../redux/ui/selectors";
import { fetchTourGuideStatus } from "../redux/ui/slice";
import { selectIsAuthLoading } from "../redux/auth/selectors";
import { useAuth0 } from "@auth0/auth0-react";

import "./home.scss";
import { LandingPageContainer } from "../components/LandingPageContainer";
import { getIsIOSDevice } from "../utils/navigator";
import { ContactButton } from "../components/ContactButton";

// const buttonIMessageText = "text with pearl";
const buttonChatText = "speak to THE PEARL™";

const Home = () => {
  document.body.classList.remove("dark-theme");

  const dispatch = useDispatch();

  const isAuthLoading = useSelector(selectIsAuthLoading);
  const hasCompletedTourGuide = useSelector(selectHasCompletedTourGuide);

  const isIOSDevice = getIsIOSDevice();

  const handleOnIMessageClicked = () => {
    history.push("/imessage-redirect");
  }

  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if(!isAuthLoading) {
      dispatch(fetchTourGuideStatus());
    }
  }, [dispatch, isAuthLoading]);

  const handleOnChatClicked = () => {
    // If user is not authenticated, trigger OAuth login flow
    // Use appState to pass the desired destination after login
    if (!isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: "/chat"
        }
      });
      return;
    }

    // If authenticated, proceed with existing logic
    if (hasCompletedTourGuide) {
      navigator.mediaDevices
        .getUserMedia({ video: false, audio: true })
        .then((mediaStream) => {
          mediaStream.getTracks().forEach((track) => track.stop());
          history.push("/chat");
        })
        .catch(() => {
          // If media access fails, still navigate to chat
          history.push("/chat");
        });

      return;
    }

    history.push("/tour-guide");
  };

  return (
    <LandingPageContainer showDisclaimerText>
      <div className="home__button-section">
        <div className="home__button">
          <Button
            variant="secondary-white"
            showBorder
            onClick={handleOnChatClicked}
          >
            {buttonChatText}
          </Button>
        </div>
        <div className="home__contact-container">
          <ContactButton />
        </div>
        {/* {isIOSDevice && (
          <div className="home__button">
            <Button
              variant="secondary"
              showBorder={true}
              onClick={handleOnIMessageClicked}
            >
              {buttonIMessageText}
            </Button>
          </div>
        )} */}
      </div>
    </LandingPageContainer>
  );
};

export default Home;
